<template>
  <div class="game" v-if="localPlayer">
    <PlayersList/>

    <div v-if="gameState.roundPhase === 'SELECTING'" :class="'cards'">
      <h1>
        <span v-if="!isMyTurn">Choose a card according to {{turn}}’s clue</span>
        <span v-if="isMyTurn">Say a clue and choose a card</span>
      </h1>
      <div class="cards_scroller">
        <!-- <span @click="drawCardFromDeck">Draw card</span> -->
        <img
          v-for="card in localPlayer.cards.slice().reverse()"
          :key="card"
          :src="`/cards/${gameState.variant}/${card}.jpg`"
          :class="`is-format-${gameState.variant} ${localPlayer.selectedCard === card ? 'is-selected' : ''}`"
          @click="selectCard(card)"
        >
      </div>
    </div>

    <div v-if="gameState.roundPhase === 'VOTING' && !isMyTurn" :class="'cards is-voting'">
      <h1>
        <span v-if="!isMyTurn">Guess which card was {{turn}}’s card</span>
      </h1>
      <div class="cards_scroller">
        <img :src="`/cards/${gameState.variant}/${localPlayer.selectedCard}.jpg`" :class="`is-format-${gameState.variant} is-self`" />
        <img
          v-for="card in votingOptionCards"
          :key="card"
          :src="`/cards/${gameState.variant}/${card}.jpg`"
          :class="`is-format-${gameState.variant} ${localPlayer.votedCard === card ? 'is-selected' : ''}`"
          @click="voteCard(card)"
        />
      </div>
    </div>

    <div v-if="gameState.roundPhase === 'VOTING' && isMyTurn" :class="'cards is-waiting'">
      <h1>
        <span>Wait until others vote</span>
      </h1>
      <div class="cards_waiting">
        <img src="/waiting.png" alt="Waiting" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import PlayersList from "./PlayersList";

export default {
  name: "Game",
  components: {
    PlayersList
  },
  computed: {
    ...mapState(["gameState"]),
    ...mapGetters([
      "turn",
      "players",
      "localPlayer",
      "isMyTurn",
      "votingOptionCards"
    ])
  },
  methods: {
    ...mapActions(["selectCard", "voteCard", "drawCardFromDeck"])
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.game {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.cards {
  width: 100%;
  border-top: 1px solid #6460AB;
  background: #3D3896;
}
.cards.is-voting,
.cards.is-waiting {
  border-top: 1px solid #8A60AB;
  background: #6D3896;
}

.cards h1 {
  text-align: center;
  height: 40px;
  margin: -22px 0 0 0;
  padding: 0 10px;
}
.cards h1 span {
  display: inline-block;
  background: white;
  border-radius: 20px;
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
  font-size: 15px;
  font-weight: 700;
  max-width: 100%;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cards_scroller {
  white-space: nowrap;
  overflow-x: scroll;
  padding: 10px 10px 20px 10px;
  -webkit-overflow-scrolling: touch;
}
.cards_scroller img {
  display: inline-block;
  vertical-align: middle;
  border-radius: 10px;
  border: none;
  background: rgba(255, 255, 255, 0.2);
  margin: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.4);
  text-align: center;
  line-height: 230px;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
}
.cards_scroller img {
  background: rgba(0,0,0,0.8) url('/spinner.gif') no-repeat center center;
}
.cards_scroller img.is-selected {
  box-shadow: 0 0 0 5px white, 0 5px 15px rgba(0, 0, 0, 0.4);
}
.cards_scroller img.is-self {
  opacity: 0.6;
}
.cards_scroller img.is-format-dixit {
  width: 156px;
  height: 230px;
}
.cards_scroller img.is-format-fbanna {
  width: 190px;
  height: 140px;
}

.cards_waiting {
  text-align: center;
  padding: 60px 0;
}
.cards_waiting img {
  height: 160px;
}
</style>
